import { Actions, ActionTypes, State, Status } from "./types";

export const initialState: State = {
  status: Status.INITIAL,
};

export const reducer = (state: State, action: Actions): State => {
  switch (action.type) {
    case ActionTypes.EXPIRED_OTP_SUCCESS: {
      return { status: Status.EXPIRED_OTP_SUCCESS };
    }
    case ActionTypes.BACK: {
      return initialState;
    }
    case ActionTypes.ERROR: {
      return { status: Status.ERROR };
    }
    case ActionTypes.EXPIRED_OTP: {
      const { createSessionUrl, token } = action.payload;
      return {
        status: Status.EXPIRED_OTP,
        createSessionUrl,
        token,
      };
    }
    case ActionTypes.SUCCESS: {
      return { status: Status.SUCCESS };
    }
    default: {
      return state;
    }
  }
};
